import get from 'lodash/get';
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
import GatewayConfig from 'app/src/data/models/GatewayConfig';
import { TERMINAL_TYPE } from 'shared_modules/Terminals';

export const supportedTerminalsForGateway = gatewayConfig => {
  let terminalsForGateway = null;

  if (gatewayConfig) {
    const supportedProcessors = get(gatewayConfig, 'parameters.supportedProcessors');
    const supportedTerminals = !(isUndefined(gatewayConfig) || isNull(gatewayConfig))
      ? get(gatewayConfig, 'supportedTerminals')
      : null;
    if (supportedProcessors && supportedTerminals) {
      // Lightspeed Payments can support multiple processors simultaneously
      terminalsForGateway = JSON.parse(supportedProcessors)
        .map(processor => {
          const supportedTerminalsByProcessor = JSON.parse(supportedTerminals)[processor];

          // @TODO: Remove this when the backend will support CLD-33307
          // The following code will make sure to add the IPP320 and ISMP4
          // to the listing of supportedTerminals for Tripos
          if (processor === GatewayConfig.GatewayType.VANTIV_TRIPOS) {
            return [
              TERMINAL_TYPE.LIGHTSPEED_IPP320_VANTIV,
              TERMINAL_TYPE.LIGHTSPEED_ISMP4_VANTIV,
              ...supportedTerminalsByProcessor,
            ];
          }

          return supportedTerminalsByProcessor;
        })
        .flat()
        .filter(
          terminal =>
            !(isUndefined(terminal) || isNull(terminal)) &&
            terminal !== TERMINAL_TYPE.LIGHTSPEED_BBPOS_CHIPPER
        );
    }
  }

  return terminalsForGateway;
};
